import Choices from 'choices.js';

export function initTournamentTable() {
    const $tournamentTableSections = $('#tournament_table_volleyball, #tournament_table_mini-football, #tournament_table_hockey')

    $tournamentTableSections.each(function() {
        const $tournamentTableSection = $(this);

        if(!$tournamentTableSection.length) return;

        const $selectTournament = $tournamentTableSection.find('[data-tournament-select]');
        const $selectSeason = $tournamentTableSection.find('[data-season-select]');
        const $selectConference = $tournamentTableSection.find('[data-conference-select]');
        const $tournamentTableBody = $tournamentTableSection.find('.tournament-table-block tbody');
        let tournamentSelectInstance = null;
        let conferenceSelectInstance = null;

        const $playoffTable = `
    <div class="table-wrapper">
            <table class="tournament-table-block hockey-tournament-table-playoff">
    `;
        const $table = `
        <div class="table-wrapper">
            <table class="tournament-table-block">
    `;
        const $playoffTableEnd = `
                </tbody>
            </table>
    </div>
`;

        const STATE = {
            selectedTournament: $selectTournament.val(),
            selectedSeason: $selectSeason.val(),
            selectedConference: $selectConference.val(),
            ajaxMode: 'dev',
            activeSportType: '',
            selectedTournamentType: 'regular',
            isConferenceSelectWillRerenderOnFront: false
        }

    init();

    function init() {
        initTournamentSelect();
        initHandlers();
    }

    function initTournamentSelect(){
        const options = {
            searchEnabled: false,
            silent: true,
            itemSelectText: '',
            allowHTML: true,
            position: 'right'
        }

        tournamentSelectInstance = new Choices($selectTournament[0], options);
        conferenceSelectInstance = new Choices($selectConference[0], options);
    }

    function initHandlers() {
        $selectTournament.on('choice', function () {
            STATE.selectedTournamentType = event.detail.choice.customProperties.type;
            STATE.selectedTournament = event.detail.choice.value;
            getTournamentTableData(false);
        });

        $selectSeason.on('change', function () {
            STATE.selectedSeason = $(this).val();
            STATE.selectedTournament = $selectTournament.val();
            getTournamentTableData(true);
        });

        $selectConference.on('change', function () {
            STATE.selectedSeason = $selectSeason.val();
            STATE.selectedTournament = $selectTournament.val();
            STATE.selectedConference = $(this).val();
            getTournamentTableData(true);
        });
    }

    function getTournamentTableData(isTournamentSelectWillRerender = false) {
        showPreload();

        const ajaxData = {
            tournament_id: STATE.selectedTournament,
            season_id: STATE.selectedSeason
        }

        const numberSportType = $('#matches .tabs-switchers').find('.switch.active').data('content-tab');

        switch(numberSportType) {
            case 1:

                STATE.activeSportType = 'volley'
                break;

            case 2:

                STATE.activeSportType = 'football'
                ajaxData.conference_id = STATE.selectedConference
                ajaxData.stage_id = STATE.selectedConference;
                break;

            case 3:

                STATE.activeSportType = 'hockey'
                ajaxData.conference_id = STATE.selectedConference
                ajaxData.stage_id = STATE.selectedConference;
                break;
        }

        $.ajax({
            url: STATE.selectedTournamentType == 'playoff' ? `/api/${STATE.activeSportType}/tournaments/tournament-table-playoff/` : `/api/${STATE.activeSportType}/tournaments/tournament-table/`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(ajaxData),
            xhrFields: {
                withCredentials: true,
            },
            success: function (data) {
                if(data && data.status !== 'error') {
                    successFn(data.data, isTournamentSelectWillRerender);

                } else {
                    errorFn();
                }
            },
            error: function (data) {
                if(STATE.ajaxMode === 'dev') {
                    setTimeout(() => {
                        data = mock;
                        if(data && data.status !== 'error') {
                            successFn(data.data, isTournamentSelectWillRerender);

                        } else {
                            errorFn();
                        }
                    }, 2000)

                } else {
                    errorFn();
                }
            },
            timeout: 30000,
        });

        function successFn(data, isTournamentSelectWillRerender){
            if(STATE.activeSportType === 'volley'){
                renderTournamentTable(data.tableData);
            } else if(STATE.activeSportType === 'football'){
                if(STATE.selectedTournamentType == 'playoff'){
                    renderFootballPlayoffTournamentTable(data);
                    rerenderConferenceSelect(data.stages);
                } else {
                    renderFootballTournamentTable(data.tableData);
                    rerenderConferenceSelect(data.stages);
                }
            } else {
                if(STATE.selectedTournamentType == 'playoff'){
                    renderHockeyPlayoffTournamentTable(data);
                    rerenderConferenceSelect(data.stages);
                } else {
                    renderHockeyTournamentTable(data.tableData);
                    rerenderConferenceSelect(data.stages);
                }
            }


            if(isTournamentSelectWillRerender){
                rerenderTournamentSelect(data.tournaments);
            } else {
                if(data.tournaments.length !== 0){
                    changeStatsLink(data.tournaments[0].link);
                }

            }
            hidePreload();
        }

        function errorFn(){
            hidePreload();
        }
    }

    function renderFootballPlayoffTournamentTable(data){
            $tournamentTableSection.find('.table-wrapper').remove();
            let tableThead = `<thead><tr>`;

            tableThead += `<th class="number-column sticky">№</th>`;
            tableThead += `<th class="team-column sticky-second">Команда</th>`;

            let tableTbody = `<tbody>`;

            const matchTitles = Object.values(data.fields).filter(title => title !== null);
            const countColumn = matchTitles.length;

            for (let i = 0; i < countColumn; i++) {
                tableThead += `<th>${matchTitles[i]}</th>`;
            }

            tableThead += `<th>Счёт</th></th></tr></thead>`;

            data.tableData.forEach(tableDataItem => {
                let tr_1 = `<tr>`;
                let tr_2 = `<tr>`;
                if(tableDataItem.club1_number && tableDataItem.club2_number){
                    tr_1 += `<td class="sticky">${tableDataItem.club1_number}</td>`
                    tr_2 += `<td class="sticky">${tableDataItem.club2_number}</td>`
                    tr_1 +=`
                <td class="sticky-second">
                    <div class="team-cell">
                        <img src="${tableDataItem.club1_logo}"/>
                            <span>${tableDataItem.club1_name}</span>
                        </div>
                    </td>
            `;

                    tr_2 += `
                <td class="sticky-second">
                    <div class="team-cell">
                        <img src="${tableDataItem.club2_logo}"/>
                            <span>${tableDataItem.club2_name}</span>
                        </div>
                    </td>
            `;
                } else {
                    tr_1 +=`
                <td class="sticky">
                    <div class="team-cell">
                        <img src="${tableDataItem.club1_logo}"/>
                            <span>${tableDataItem.club1_name}</span>
                        </div>
                    </td>
            `;

                    tr_2 += `
                <td class="sticky">
                    <div class="team-cell">
                        <img src="${tableDataItem.club2_logo}"/>
                            <span>${tableDataItem.club2_name}</span>
                        </div>
                    </td>
            `;
                }


                for(let i = 1; i <= countColumn; i++){
                    let positionTd = getPosScoreTdHTML(i, tableDataItem);
                    if(tableDataItem[`match${i}_position`] === 'up'){
                        tr_1 += positionTd;
                        tr_2 += `<td></td>`;
                    } else {
                        tr_2 += positionTd;
                        tr_1 += `<td></td>`
                    }
                }

                tr_1 += `<td class="final-score bold" rowspan="2">${tableDataItem.points}</td></tr>`
                tr_2 += `</tr>`
                tableTbody += tr_1 + tr_2;
            })

            let resultTable = $playoffTable;
            resultTable += tableThead;
            resultTable += tableTbody;
            resultTable += $playoffTableEnd;

            $tournamentTableSection.find('.tournament-table-selects').after(resultTable);

            tableTbody = `<tbody>`;
        }

        function rerenderConferenceSelect(stages) {
            const newOptions = [];

            if(stages){
                STATE.isConferenceSelectWillRerenderOnFront = false;
            } else {
                if($selectConference.val() == 0 || $selectConference.val() == 1){
                    return
                } else {
                    STATE.isConferenceSelectWillRerenderOnFront = true;
                }
            }

            switch (STATE.isConferenceSelectWillRerenderOnFront){
                case false :
                    stages.forEach(stageItem => {
                        const {
                            id,
                            name,
                            isSelected
                        } = stageItem;

                        newOptions.push(
                            {
                                value: id,
                                label: name,
                                selected: isSelected
                            },
                        )
                    });

                    conferenceSelectInstance.setChoices(newOptions,  'value', 'label', true)
                    STATE.isConferenceSelectWillRerenderOnFront = true;
                    break;

                case true :
                    conferenceSelectInstance.setChoices([{value: '0', label: 'Восток', selected: false},{value: '1', label: 'Запад', selected: true}],  'value', 'label', true)
                    break;

            }
        }
        function renderHockeyPlayoffTournamentTable(data) {
            $tournamentTableSection.find('.table-wrapper').remove();
            $tournamentTableSection.find('[data-title]').remove();
            let tableThead = `<thead><tr>`;

            tableThead += `<th class="number-column sticky">№</th>`;
            tableThead += `<th class="team-column sticky-second">Команда</th>`;

            let tableTbody = `<tbody>`;

            const matchTitles = Object.values(data.fields).filter(title => title !== null);
            const countColumn = matchTitles.length;

            for (let i = 0; i < countColumn; i++) {
                tableThead += `<th>${matchTitles[i]}</th>`;
            }

            tableThead += `<th>Счёт</th></th></tr></thead>`;

            data.tableData.forEach(tableDataItem => {
                let tr_1 = `<tr>`;
                let tr_2 = `<tr>`;
                if(tableDataItem.club1_number && tableDataItem.club2_number){
                    tr_1 += `<td class="sticky">${tableDataItem.club1_number}</td>`
                    tr_2 += `<td class="sticky">${tableDataItem.club2_number}</td>`
                    tr_1 +=`
                <td class="sticky-second">
                    <div class="team-cell">
                        <img src="${tableDataItem.club1_logo}"/>
                            <span>${tableDataItem.club1_name}</span>
                        </div>
                    </td>
            `;

                    tr_2 += `
                <td class="sticky-second">
                    <div class="team-cell">
                        <img src="${tableDataItem.club2_logo}"/>
                            <span>${tableDataItem.club2_name}</span>
                        </div>
                    </td>
            `;
                } else {
                    tr_1 +=`
                <td class="sticky">
                    <div class="team-cell">
                        <img src="${tableDataItem.club1_logo}"/>
                            <span>${tableDataItem.club1_name}</span>
                        </div>
                    </td>
            `;

                    tr_2 += `
                <td class="sticky">
                    <div class="team-cell">
                        <img src="${tableDataItem.club2_logo}"/>
                            <span>${tableDataItem.club2_name}</span>
                        </div>
                    </td>
            `;
                }


                for(let i = 1; i <= countColumn; i++){
                    let positionTd = getPosScoreTdHTML(i, tableDataItem);
                    if(tableDataItem[`match${i}_position`] === 'up'){
                        tr_1 += positionTd;
                        tr_2 += `<td></td>`;
                    } else {
                        tr_2 += positionTd;
                        tr_1 += `<td></td>`
                    }
                }

                tr_1 += `<td class="final-score bold" rowspan="2">${tableDataItem.points}</td></tr>`
                tr_2 += `</tr>`
                tableTbody += tr_1 + tr_2;
            })

            let resultTable = $playoffTable;
            resultTable += tableThead;
            resultTable += tableTbody;
            resultTable += $playoffTableEnd;

            let resultHTML = `
                <div class="section-title xs-variant with-margin-top" data-title="1">
            <h2 class="title">Запад</h2>
        </div>
        `;

            resultHTML += resultTable;

            tableTbody = `<tbody>`;

            // Если 2 таблица есть - рендерим её, если нет скрываем тайтлы таблиц
            if(data.table2Data.length != 0){
                data.table2Data.forEach(tableDataItem => {
                    let tr_1 = `<tr>`;
                    let tr_2 = `<tr>`;
                    if(tableDataItem.club1_number && tableDataItem.club2_number){
                        tr_1 += `<td class="sticky">${tableDataItem.club1_number}</td>`
                        tr_2 += `<td class="sticky">${tableDataItem.club2_number}</td>`
                        tr_1 +=`
                <td class="sticky-second">
                    <div class="team-cell">
                        <img src="${tableDataItem.club1_logo}"/>
                            <span>${tableDataItem.club1_name}</span>
                        </div>
                    </td>
            `;

                        tr_2 += `
                <td class="sticky-second">
                    <div class="team-cell">
                        <img src="${tableDataItem.club2_logo}"/>
                            <span>${tableDataItem.club2_name}</span>
                        </div>
                    </td>
            `;
                    } else {
                        tr_1 +=`
                <td class="sticky">
                    <div class="team-cell">
                        <img src="${tableDataItem.club1_logo}"/>
                            <span>${tableDataItem.club1_name}</span>
                        </div>
                    </td>
            `;

                        tr_2 += `
                <td class="sticky">
                    <div class="team-cell">
                        <img src="${tableDataItem.club2_logo}"/>
                            <span>${tableDataItem.club2_name}</span>
                        </div>
                    </td>
            `;
                    }

                    for(let i = 1; i <= countColumn; i++){
                        let positionTd = getPosScoreTdHTML(i, tableDataItem);
                        if(tableDataItem[`match${i}_position`] === 'up'){
                            tr_1 += positionTd;
                            tr_2 += `<td></td>`;
                        } else {
                            tr_2 += positionTd;
                            tr_1 += `<td></td>`
                        }
                    }

                    tr_1 += `<td class="final-score bold" rowspan="2">${tableDataItem.points}</td></tr>`
                    tr_2 += `</tr>`
                    tableTbody += tr_1 + tr_2;
                })

                resultTable = $playoffTable;
                resultTable += tableThead;
                resultTable += tableTbody;
                resultTable += $playoffTableEnd;


                resultHTML += `
                <div class="section-title xs-variant with-margin-top" data-title="2">
            <h2 class="title">Восток</h2>
        </div>
        ` + resultTable;
            }

            $tournamentTableSection.find('.tournament-table-selects').after(resultHTML);
            hidePreload();
        }

        // Создание td с результатом матча
        function getPosScoreTdHTML(count, data){
            return `<td>${data[`match${count}_score`]}</td>`
        }

    function renderTournamentTable(tableData){
        let tableHTML = '';

        if(tableData.length === 0){
            tableHTML += `<tr>
                    <td>-</td>
                    <td>
                        <div class="team-cell">
                            <span>-</span>
                        </div>
                    </td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>`

            $tournamentTableBody.html(tableHTML)
            return
        }

        tableData.forEach(tableDataItem => {
            const {num,
                club_logo,
                club_name,
                games,
                win,
                loss,
                three_zero,
                three_one,
                three_two,
                two_three,
                one_three,
                zero_three,
                points,
                sets,
                odds,
                balls,
                balls_odds,
                isHighLighted,
            } = tableDataItem;

            tableHTML += `<tr class="${isHighLighted ? 'highlighted' : ''}">
                    <td class="number-column">${num}</td>
                    <td class="team-column">
                        <div class="team-cell">
                            <img src="${club_logo}"/>
                            <span>${club_name}</span>
                        </div>
                    </td>
                    <td class="games-column">${games}</td>
                    <td class="wins-column bold">${win}</td>
                    <td class="loses-column">${loss}</td>
                    <td class="column-3-0">${three_zero}</td>
                    <td class="column-3-1">${three_one}</td>
                    <td class="column-3-2">${three_two}</td>
                    <td class="column-2-3">${two_three}</td>
                    <td class="column-1-3">${one_three}</td>
                    <td class="column-0-3">${zero_three}</td>
                    <td class="bold column-0">${points}</td>
                    <td class="sets-column">${sets}</td>
                    <td class="coeff1-column">${odds}</td>
                    <td class="balls-column">${balls}</td>
                    <td class="coeff2-column">${balls_odds}</td>
                </tr>`
        })

        $tournamentTableBody.html(tableHTML)
    }

    function renderHockeyTournamentTable(tableData){
            $tournamentTableSection.find('.table-wrapper').remove();
            $tournamentTableSection.find('[data-title]').remove();

            let tableThead = `<thead><tr>`;

            tableThead += `<th class="number-column sticky">№</th>`;
            tableThead += `<th class="team-column sticky-second">Команда</th>`;
            tableThead += `<th>Игр</th>`;
            tableThead += `<th>В</th>`;
            tableThead += `<th>ВО</th>`;
            tableThead += `<th>ВБ</th>`;
            tableThead += `<th>ПБ</th>`;
            tableThead += `<th>ПО</th>`;
            tableThead += `<th>П</th>`;
            tableThead += `<th>Шайбы</th>`;
            tableThead += `<th>Очки</th>`;

            let tableTbody = `<tbody>`;

            tableThead += `</tr></thead>`;

        if(tableData.length === 0){
            tableTbody += `<tr>
                    <td>-</td>
                    <td>
                        <div class="team-cell">
                            <span>-</span>
                        </div>
                    </td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                     <td>-</td>
                </tr>`
        } else {
            tableData.forEach(tableDataItem => {
                const {
                    num,
                    club_logo,
                    club_name,
                    games,
                    win,
                    win_overtime,
                    win_shootout,
                    loss_shootout,
                    loss_overtime,
                    loss,
                    pucks,
                    points,
                    isHighLighted,
                } = tableDataItem;

                tableTbody += `<tr class="${Boolean(+isHighLighted) ? 'highlighted' : ''}">
                    <td>${num}</td>
                    <td>
                        <div class="team-cell">
                            <img src="${club_logo}"/>
                            <span>${club_name}</span>
                        </div>
                    </td>
                    <td>${games}</td>
                    <td>${win}</td>
                    <td>${win_overtime}</td>
                    <td>${win_shootout}</td>
                    <td>${loss_shootout}</td>
                    <td>${loss_overtime}</td>
                    <td>${loss}</td>
                    <td>${pucks}</td>
                     <td>${points}</td>
                </tr>`
            })
        }

            let resultHTML = $table + tableThead + tableTbody + $playoffTableEnd;

            $tournamentTableSection.find('.tournament-table-selects').after(resultHTML)
        }
        function renderFootballTournamentTable(tableData){
            let tableHTML = '';

            $tournamentTableSection.find('.table-wrapper').remove();

            tableHTML+= `<div class="table-wrapper">
        <table class="tournament-table-block">
        <thead>
          <tr>
            <th class="number-column sticky">№</th>
            <th class="team-column sticky-second">Команда</th>
            <th>Игр</th>
            <th>В</th>
            <th>П</th>
            <th>ВП</th>
            <th>ПП</th>
            <th class="balls-column">Мячи</th>
            <th>Очки</th>
          </tr>
        </thead>
        `

            if(tableData.length === 0){
                tableHTML += `<tr>
                    <td>-</td>
                    <td>
                        <div class="team-cell">
                            
                            <span>-</span>
                        </div>
                    </td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                     <td>-</td>
                </tr>`
            } else {

                tableData.forEach(tableDataItem => {
                    const {
                        num,
                        club_logo,
                        club_name,
                        games,
                        win,
                        loss,
                        points,
                        balls,
                        win_penalty,
                        loss_penalty,
                        isHighLighted,
                    } = tableDataItem;

                    tableHTML += `<tr class="${Boolean(+isHighLighted) ? 'highlighted' : ''}">
                    <td>${num}</td>
                    <td>
                        <div class="team-cell">
                            <img src="${club_logo}"/>
                            <span>${club_name}</span>
                        </div>
                    </td>
                    <td>${games}</td>
                    <td>${win}</td>
                    <td>${loss}</td>
                    <td>${win_penalty}</td>
                    <td>${loss_penalty}</td>
                    <td>${balls}</td>
                     <td>${points}</td>
                </tr>`
                })
            }

            tableHTML += `</table></div>`

            $tournamentTableSection.find('.tournament-table-selects').after(tableHTML)
        }

    function rerenderTournamentSelect(tournaments){
        const newOptions = [];

        tournaments.forEach(tournamentItem => {
            const {
                id,
                name,
                isSelected,
                link,
                type
            } = tournamentItem;

            if(isSelected === true){
                changeStatsLink(link);
            }

            newOptions.push(
                {
                    value: id,
                    label: name,
                    selected: isSelected,
                    customProperties: {
                        type: type
                    }
                },
            )
        });

        tournamentSelectInstance.setChoices(newOptions,  'value', 'label', true)
    }

    function changeStatsLink(link){
            $tournamentTableSection.find('.title-link').attr('href',link);
    }

    function showPreload(){
        $('.tournament-table-selects').addClass('load');
        $('.table-wrapper').addClass('load');
    }

    function hidePreload(){
        $('.tournament-table-selects').removeClass('load');
        $('.table-wrapper').removeClass('load');
    }

    const mock = {
        tournaments: [
            {
                id: 123,
                name: 'AjaxТурнир1',
                isSelected: true,
                link: 'kek.html'
            },
            {
                id: 321,
                name: 'AjaxТурнир2',
                isSelected: false
            },
            {
                id: 321,
                name: 'AjaxТурнир3',
                isSelected: false
            }
        ],
        tableData: [
            {
                num: 1,
                club_logo: './img/logo-small-volley.svg',
                club_name: 'ФакелAjax1',
                games: 99,
                win: 12,
                loss: 87,
                three_zero: 12,
                three_one: 22,
                three_two: 32,
                two_three: 31,
                one_three: 20,
                zero_three: 22,
                points: 32,
                sets: '88:13',
                odds: '4,53',
                balls: '2481:1900',
                balls_odds: '0,94',
                isHighLighted: true
            },
            {
                num: 2,
                club_logo: './img/logo-small-volley.svg',
                club_name: 'ФакелAjax2',
                games: 99,
                win: 12,
                loss: 87,
                three_zero: 12,
                three_one: 22,
                three_two: 32,
                two_three: 31,
                one_three: 20,
                zero_three: 22,
                points: 32,
                sets: '88:13',
                odds: '4,53',
                balls: '2481:1900',
                balls_odds: '0,94',
                isHighLighted: false
            },
            {
                num: 2,
                club_logo: './img/logo-small-volley.svg',
                club_name: 'ФакелAjax3',
                games: 99,
                win: 12,
                loss: 87,
                three_zero: 12,
                three_one: 22,
                three_two: 32,
                two_three: 31,
                one_three: 20,
                zero_three: 22,
                points: 32,
                sets: '88:13',
                odds: '4,53',
                balls: '2481:1900',
                balls_odds: '0,94',
                isHighLighted: false
            },
        ],
    }
})
}